import { ga, adjust } from 'js/analytics/adapters'

export const trackCompleteRegistration = ({
  profile,
}: {
  profile: { id: number }
}) => {
  ga.track('complete_registration')
  adjust.track('Complete Registration', profile.id)
}
